<template>
  <div class="schedule-resume">
    <div class="container">
      <div class="schedule-resume__cards">
        <div class="schedule-resume__infor-card">
          <div class="schedule-resume__card-top">
            <h2 class="schedule-resume__maintitle">Calendário de consultas</h2>
            <div class="schedule-resume__card-buttons">
              <button class="button4 mr-2" @click="deleteSchedule">Reconfigurar agenda</button>
            </div>
          </div>

          <div class="schedule-resume__card-middle">
            <div class="schedule-resume__infor-group">
              <div class="schedule-resume__infor-group-item">
                <small class="schedule-resume__subtitle">
                  {{ startAtLabel }}:
                </small>
                <h6 class="schedule-resume__title">
                  {{
                    formatConfigSlotDate(
                      this.configSlot.from_date,
                      "d 'de' MMMM 'de' y"
                    )
                  }}
                </h6>
              </div>

              <div class="schedule-resume__infor-group-item">
                <small class="schedule-resume__subtitle">
                  Finaliza em:
                </small>
                <h6 class="schedule-resume__title">
                  {{
                    formatConfigSlotDate(
                      this.configSlot.until_date,
                      "d 'de' MMMM 'de' y"
                    )
                  }}
                </h6>
              </div>

              <div class="schedule-resume__infor-group">
                <div class="schedule-resume__infor-group-item">
                  <small class="schedule-resume__subtitle">
                    Dias de atendimento:
                  </small>
                  <h6 class="schedule-resume__title">
                    {{ workDays }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { slotMethods } from "./../state/helpers";
import { isPast, isFuture, parseISO } from "date-fns";
import { formatDate } from "./../utils/masks/formatSlotDate";

export default {
  name: "ScheduleResume",
  props: {
    doctorId: {
      type: String,
      default: '',
    },
    unitId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      configSlot: {},
      days: [
        { name: "sunday", translate: "Domingo", day_of_week: 0 },
        { name: "monday", translate: "Segunda", day_of_week: 1 },
        { name: "tuesday", translate: "Terça", day_of_week: 2 },
        { name: "wednesday", translate: "Quarta", day_of_week: 3 },
        { name: "thursday", translate: "Quinta", day_of_week: 4 },
        { name: "friday", translate: "Sexta", day_of_week: 5 },
        { name: "saturday", translate: "Sábado", day_of_week: 6 }
      ]
    };
  },
  mounted() {
    this.getConfig(`doctor_id=${this.doctorId}&unit_id=${this.unitId}`).then(response => {
      if (response.data.schedule_config === null) {
        this.$store.commit("slot/SET_HAS_SLOTS", false);
      } else {
        this.configSlot = response.data.schedule_config;
      }
    });
  },
  methods: {
    ...slotMethods,
    formatConfigSlotDate(date, format) {
      if (!date) return "";

      if (date.includes('/')) {
        let formattedDate;
        let splittedDate = date.split('/');
        formattedDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        return formatDate(formattedDate, format);
      }

      return formatDate(date, format);
    },
    deleteSchedule() {
      swal.fire({
        title: "Confirmar!",
        text: `Tem certeza disso? Caso clique em "continuar", suas configurações atuais da agenda serão desfeitas
               e você deverá configurar sua agenda novamente. Mas não se preocupe com suas consultas 
               já agendadas, pois elas não  serão desmarcadas.`,
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.deleteSlot(`doctor_id=${this.doctorId}&unit_id=${this.unitId}`);
          this.$store.commit("slot/SET_HAS_SLOTS", false);
          this.$store.commit("slot/SET_CREATING_SCHEDULE", true);
        }
      });
    }
  },
  computed: {
    userPhoto() {
      return `background:url(${require("../assets/images/me.jpg")});`;
    },
    startAtLabel() {
      return isPast(this.configSlot.from_date) ? "Iniciado em" : "Inicia em";
    },
    workDays() {
      return this.configSlot.work_days
        .map(day => {
          return this.days.filter(
            week_day => week_day.day_of_week === day.day_of_week
          )[0].translate;
        })
        .join(", ");
    }
  }
};
</script>

<style lang="css" scoped>
.schedule-resume {
  margin: 4em 0;
}
.schedule-resume > .container {
  max-width: 1200px !important;
  padding: 0px !important;
}
.schedule-resume__cards {
  display: grid;
  /* grid-template-columns: 3fr 1fr; */
  grid-template-columns: 1fr;
  gap: 20px;
}
@media (max-width: 992px) {
  .schedule-resume > .container {
    padding: 12px 16px !important;
  }
  .schedule-resume__cards {
    grid-template-columns: 1fr;
  }
  .schedule-resume__infor-card {
    order: 2;
  }
  .schedule-resume__patient-card {
    order: 1;
  }
}
.schedule-resume__infor-card {
  background: #fff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}
.schedule-resume__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.5em 2.2em;
  border-bottom: 1px solid #eaeaea;
}
.schedule-resume__maintitle {
  margin: 0px !important;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.5px;
  color: #333333;
}
.schedule-resume__card-buttons {
  display: flex;
}
@media (max-width: 768px) {
  .schedule-resume__card-top {
    flex-direction: column;
  }
  .schedule-resume__card-buttons {
    margin-top: 1.1em;
  }
}
.schedule-resume__button {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid #ddd;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  transition: all 0.3s ease;
}
.schedule-resume__button:first-child {
  margin-right: 0.571em;
}
.schedule-resume__button:hover,
.schedule-resume__button:focus {
  border-color: #222;
  outline: none;
}
.schedule-resume__button > img {
  margin-right: 0.571em;
}

.schedule-resume__card-middle {
  padding: 1.1em 2.2em;
  display: flex;
  align-items: center;
}
.schedule-resume__infor-group:nth-child(1) {
  margin-right: 5em;
}
@media (max-width: 576px) {
  .schedule-resume__card-middle {
    flex-direction: column;
    align-items: flex-start;
  }
}
.schedule-resume__infor-group-item {
  margin: 1.1em 0;
}
.schedule-resume__subtitle {
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #999999;
}
.schedule-resume__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #333333;
}
.schedule-resume__card-bottom {
  display: flex;
  align-items: center;
  padding: 1.1em 2.2em 2.2em 2.2em;
}
.schedule-resume__card-bottom > img {
  margin-right: 1.1em;
}
.schedule__observation {
  max-width: 690px;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.25px;
  word-wrap: break-word;
  color: #999999;
}

.schedule-resume__patient-card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1.1em 0;
  text-align: center;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
}
.schedule-resume__avatar {
  margin: 1.7em 0;
}
.schedule-resume__image-wrapper {
  border: 4px solid #f8002d;
  border-radius: 20em;
}
.schedule-resume__image {
  height: 72px;
  width: 72px;
  /* background: url('../assets/images/me.jpg'); */
  background-size: cover !important;
  border: 4px solid #fff;
  border-radius: 20em;
}
.schedule-resume__patient-card > small {
  margin-bottom: 0.2em;
}
.schedule-resume__patient-card > h6 {
  max-width: 180px;
  word-wrap: break-word;
}
@media (max-width: 992px) {
  .schedule-resume__patient-card > h6 {
    max-width: 100%;
  }
}
.schedule-resume__patient-card > button {
  margin: 1.7em 0;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #f8002d;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  background-color: #fff;
  color: #f8002d !important;
  stroke: #f8002d;
  transition: all 0.3s ease;
}
.schedule-resume__patient-card > button:hover,
.schedule-resume__patient-card > button:focus {
  outline: none !important;
  background: #f8002d !important;
  color: #fff !important;
  stroke: #fff !important;
}
.schedule-resume__patient-card > button svg {
  margin-right: 0.5em;
}
.schedule-resume__estimated-time {
  margin: 1.1em 0 !important;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  color: #999;
}
.schedule-resume__estimated-time > b {
  color: #333;
}
</style>
